import Vue from 'vue'
import Apis from './apis'
// import tg_icon from '../assets/tg_icon.png'
const tg_icon = 'https://scenic.tuliyou.com/static/images/classify_icon_coupon.png'

const voice_icon = 'https://scenic.tuliyou.com/static/images/default_page_images/scenic/voice_icon.png'

// const star_icon = require('../assets/prize_star.png')
const star_icon = require('../assets/prize_star.png')

let infoWindow = {}

// let popupClickNum = 0;
export default {
    // 判断iphonex以上型号
    isIphoneX(){
        const xSeriesConfig = [
            {
              devicePixelRatio: 3,
              width: 375,
              height: 812,
            },
            {
              devicePixelRatio: 3,
              width: 414,
              height: 896,
            },
            {
              devicePixelRatio: 2,
              width: 414,
              height: 896,
            },
            {
              devicePixelRatio: 3,
              width: 315,
              height: 812,
            },
            {
              devicePixelRatio: 3,
              width: 390,
              height: 844,
            },
            {
              devicePixelRatio: 3,
              width: 428,
              height: 926,
            }
          ]
          // h5
          if (typeof window !== 'undefined' && window) {
            const isIOS = /iphone/gi.test(window.navigator.userAgent)
            if (!isIOS) return false
            const { devicePixelRatio, screen } = window
            const { width, height } = screen
            return xSeriesConfig.some(item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height)
          }
          return false
    },
    registerJSSDK(sid) {
        return new Promise((resolve, reject) => {
            Vue.axios.post(Apis.registerSDK, { sid: sid, url: location.href }).then(res => {
                // alert(JSON.stringify(res))
                window.uni.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名
                    jsApiList: ['getLocation', 'openLocation'] // 必填，需要使用的JS接口列表
                })
                window.uni.ready(() => {
                    resolve()
                })
                window.uni.error(() => {
                    reject('微信JSSDK注册失败！')
                })
            })
        })
    },
    /**
     * 获取当前位置
     */
    geolocation() {
        return new Promise((resolve, reject) => {
            window.uni.getLocation({
                type: 'gcj02', // 火星坐标系
                altitude:true,
                isHighAccuracy:true,
                success(res) {
                    resolve(res)
                },
                fail(err) {
                    reject(err)
                }
            })
        })
    },
    /**
     * 百度坐标转gcj02（传入经度、纬度）
     * @param {Float} bd_lng
     * @param {Float} bd_lat
     */
    bd_decrypt(bd_lng, bd_lat) {
        const X_PI = (Math.PI * 3000.0) / 180.0
        const x = bd_lng - 0.0065
        const y = bd_lat - 0.006
        const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
        const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
        const gg_lng = z * Math.cos(theta)
        const gg_lat = z * Math.sin(theta)
        return { lng: gg_lng, lat: gg_lat }
    },
    /**
     * gcj02转百度坐标（传入经度、纬度）
     * @param {Float} gg_lng
     * @param {Float} gg_lat
     */
    bd_encrypt(gg_lng, gg_lat) {
        const X_PI = (Math.PI * 3000.0) / 180.0
        const x = gg_lng,
            y = gg_lat
        const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI)
        const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI)
        const bd_lng = z * Math.cos(theta) + 0.0065
        const bd_lat = z * Math.sin(theta) + 0.006
        return { lng: bd_lng, lat: bd_lat }
    },
    /**
     * 清楚地图上的点 线 信息窗口
     * @param {*} obj
     */
    cleanMapOverlays(obj) {
        if(!Object.values(obj.map).length && Object.values(obj.$store.state.mapObj).length) obj.map = obj.$store.state.mapObj
        // 获取现有的marker点
        const oldMarkers = obj.$store.state.mapMarkers
        // 清除旧的marker点
        obj.map.remove(oldMarkers)
        // 清楚旧的聚合点
        const mco = obj.$store.state.markerClustererObj
        mco.clearMarkers && mco.clearMarkers()
        // 清除之前的线路
        const lines = obj.map.getAllOverlays('polyline')
        obj.map.remove(lines)
        // 清除地图上的infowindow
        obj.map.clearInfoWindow()

        return new Promise(resolve => {
            resolve()
        })
    },
    /**
     * 计算两点距离，获取距离最近的数据索引
     * @param {LngLatObject} dataList
     * @param {LngLatObject} userLocation
     * @return {Number} index
     */
    calculatePointDistance(dataList, userLocation) {
        console.log('dataList', dataList == '', dataList)
        if (dataList == '') {
            return ''
        }
        // 有多个图层选择距离最近的那个图层展示
        let discArr = []
        dataList.forEach(el => {
            // 计算距离
            const centerPoint = el.p_c.split(',')
            const pointOne = new AMap.LngLat(userLocation[0], userLocation[1])
            const pointTwo = new AMap.LngLat(centerPoint[0], centerPoint[1])
            discArr.push(pointOne.distance(pointTwo))
        })
        console.log('discArr', discArr)
        const minNum = Math.min.apply(Math, discArr)
        console.log('min:', minNum)
        const minNumIx = discArr.indexOf(minNum)
        console.log('minNumIx:', minNumIx)
        return minNumIx
    },
    /**
     * 地图上绘制出景点
     */
    drawPoint(vueObj) {
        // 清理地图上的点
        this.cleanMapOverlays(vueObj).then(() => {
            vueObj.markers = []
        })
        // 获取当前选择的分类的数据
        const scenicList = vueObj.$store.state.curScenicList
        // 获取用户的位置信息
        // const userPosition = vueObj.$store.state.userLocation
        // // 转换成高德的lnglat对象
        // const lngLat = new AMap.LngLat(userPosition[0], userPosition[1])
        // // 中心点位置
        // const cll = this.bd_decrypt(vueObj.$store.state.scenicInfo.lng, vueObj.$store.state.scenicInfo.lat)
        // const centerPosition = new AMap.LngLat(cll.lng, cll.lat)
        // 信息框对象
        infoWindow = new AMap.InfoWindow({
            isCustom: true,
            autoMove: true,
            offset: new AMap.Pixel(0, -50)
        })

        // 循环处理点数据
        scenicList.forEach(el => {
            // 如果有有经纬度为空者不操作
            if (el.lng == '' || el.lat == '' || isNaN(el.lng) || isNaN(el.lat)) return
            // 自定义标记点
            // 2022/9/21 不显示音频图标 显示逻辑为在audio-btn的class后加${el.audio != '' ? 'show': ''}
            
            let distance = isNaN(Number(el.distance)) ? el.distance : (el.distance/1000) + 'km'
            const content = `<div class="custor-marker-point">
                    <div class='top-info-box'>
                    <div class='top-title'>
                        <div class='spot-name' onclick='showDetail(${el.id})'>${el.title}</div>
                        <div class='audio-btn' onclick='splayAudio(this, ${JSON.stringify(el.audio)})'>
                            <div class="music-wrap">
                                <ul class="music">
                                    <li class="m1"></li>
                                    <li class="m2"></li>
                                    <li class="m3"></li>
                                    <li class="m1"></li>
                                    <li class="m2"></li>
                                    <li class="m3"></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                        <div class='bottom'>
                        <img src='${el['thumb'] || (!el.id && vueObj.curClassify.icon)}'  onclick='showDetail(${el.id})'/>
                        <div class='info-box'>
                            
                            <div class='distance' onclick='showDetail(${el.id})'>距您${distance}</div>
                            <div class='btn'>
                                <button class='detail' style='display:${(el.ctype == 1 || el.ctype == 2 || el.ctype == 3) && el.cstatus == 2 && el.id?'':'none'}' onclick='lookDetail()'>查看详情</button>
                                ${ vueObj.$store.state.isWeiXin ? '<button class=\'go-address\' onclick=\'goHere()\'>去这里</button>' : '' }
                            </div>
                        </div>
                        </div>

                    </div>
                </div>`


            const labelContent = `
            <div class="label-item ${el.question && el.question.id ? 'prize' : ''}">
                <img class="prize-star" src="${star_icon}" alt="">
                <span>${el.title}</span>
            </div>
            `
            
            const marker = new AMap.Marker({
                position: [el.lng, el.lat],
                // offset: new AMap.Pixel(-18, -37),
                icon: new AMap.Icon({
                    // image: el.flag_c == 1 ? tg_icon : vueObj.curClassify.icon,
                    image: el.audio.length >= 1 ? voice_icon : vueObj.curClassify.icon,
                    imageSize: new AMap.Size(36, 36)
                }),
                animation: el.flag_c == 1 ? 'AMAP_ANIMATION_DROP' : 'AMAP_ANIMATION_NONE',
                topWhenClick: true,
                extData: el,
                bubble: false,
                clickable: true,
                // 设置底部label
                label: {
                    offset: new AMap.Pixel(8, 40),
                    content: labelContent
                }
            })


            marker.content = content
            // 点击景点标记时显示标记上方的小框
            AMap.event.addListener(marker, 'mousedown', clickCallback)
            AMap.event.addListener(marker, 'touchstart', clickCallback)
            function clickCallback(e) {
                // start 处理景点标记点击时事件穿透导致直接播放音频问题
                let audioEl = document.getElementsByClassName('audio-box')[0]
                if(audioEl) {
                    audioEl.style.pointerEvents = 'none'
                    setTimeout(() => {
                        audioEl.style.pointerEvents = ''
                    }, 300)
                }
                // end

                // alert(e)
                // 打开消息框
                window.showDetail(el.id)             
                infoWindow.setContent(e.target.content)
                // infoWindow.open(vueObj.map, e.target.getPosition())
                // 设置当前选择的点
                vueObj.$store.commit('setCurScenicItem', el)
                // 更改播放状态
                vueObj.playStatus = false
            }
            vueObj.markers.push(marker)
            vueObj.$store.commit('setMapMarkers', marker)
        })
        // 不在范围内的话将地图中心移动到最近的点位置
        // if (vueObj.bounds != null && !vueObj.bounds.contains(lngLat)) {
        //     console.log('[centerPosition]', centerPosition)
        //     vueObj.map.panTo(centerPosition);
        // }else{
        //     // 默认打开一个信息框
        //     if(popupClickNum == 0){
        //         vueObj.markers[0].emit('click', { target: vueObj.markers[0] });
        //         popupClickNum += 1;
        //     }
        // }
        // 点击地图关闭信息窗口
        // vueObj.map.on('click', () => {
        //     infoWindow.close()
        // })
        AMap.event.addListener(vueObj.map, 'touchstart', () => {
            infoWindow.close()
        })

        // 聚合点设置
        this.markerClusterer(vueObj)

    },
    // 集合点设置
    markerClusterer(vueObj) {
        // 获取全景图信息
        const panoramaInfo = vueObj.$store.state.panoramaInfo
        // 没有map对象直接返回
        if (!vueObj.map) return
        // 判断有没有聚合点
        if (vueObj.markerClustererObj) {
            vueObj.markerClustererObj.setMap(null)
            vueObj.markerClustererObj.clearMarkers()
        }
        // 使用聚合点
        vueObj.markerClustererObj = new AMap.MarkerClusterer(vueObj.map, vueObj.markers, {
            renderCluserMarker: this._renderCluserMarker.bind(vueObj),
            gridSize: 80,
            maxZoom: panoramaInfo.max - 2,
            averageCenter: false,
            zoomOnClick: true
        })
        // AMap.event.addListener(vueObj.markerClustererObj, 'click', (el) => {
        //     console.log(el)
        //     vueObj.map.setZoomAndCenter(panoramaInfo.max, [el.lnglat.lng, el.lnglat.lat])
        // })
        // 设置全局聚合点对象
        vueObj.$store.commit('setMarkerClustererObj', vueObj.markerClustererObj)
    },
    // 自定义点聚合样式
    _renderCluserMarker(ctx) {
        //  计算出label居中需要偏移的参数
        const getOffsetPixel1 = text => {
            let textSize = compuleText(text)
            return new AMap.Pixel(8, textSize.h+5)
        }
        //  计算marker label的宽高
        const compuleText = v => {
            let d = document.getElementById('dvCompute')
            document.getElementById('dvText').innerHTML = v
            return { w: d.offsetWidth, h: d.offsetHeight * 2 }
        }
        // 如果当前要显示的info窗口在聚合点内就关闭info窗口
        const curSelectSeneic = this.$store.state.curScenicItem
        if (infoWindow.getIsOpen()) {
            ctx.markers.forEach(el => {
                if (el.getExtData().id == curSelectSeneic.id) {
                    infoWindow.close()
                }
            })
        }

        

        const div = document.createElement('div')
        div.className = 'marker-clusterer-icon'
        div.innerHTML = ctx.count
        ctx.marker.setContent(div)
        // 设置文字
        // let labelName = `${ctx.markers[0].getExtData().title}...等`
        let labelName = ctx.markers[0].getExtData().title
        let sizeOfPix = getOffsetPixel1(labelName)
        const labelContent = `
        <div class="label-item">
            <img class="prize-star" src="${star_icon}" alt="">
            <span>${labelName}</span>
        </div>
        `
        ctx.marker.setLabel({
            // content: `<p><span>${labelName}</span></p>`,
            content: labelContent,
            offset: sizeOfPix
        })
    },
    // 富文本匹配
	formatImg(html) {
		var newContent= html.replace(/<img[^>]*>/gi,(match,capture) => {
			// var match = match.replace(/style=\"(.*)\"/gi, '');
			return match.replace(/style=\"(.*)\"/gi, '')
		})
		return newContent
	},
    getTwoPointsDistance(coord1, coord2) {
        const R = 6371e3 // 地球半径（米）

        const lat1 = coord1.latitude * Math.PI / 180 // 纬度转为弧度
        const lat2 = coord2.latitude * Math.PI / 180 // 纬度转为弧度
        const deltaLat = (coord2.latitude - coord1.latitude) * Math.PI / 180 // 纬度差转为弧度
        const deltaLon = (coord2.longitude - coord1.longitude) * Math.PI / 180 // 经度差转为弧度

        const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
                Math.cos(lat1) * Math.cos(lat2) *
                Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

        const distance = R * c // 计算得到的距离（米）
        return distance
    }
}
